<template>
  <div v-if="contact" class="shop-contact">
    <div
      class="shop-contact__thumbnail"
      :style="{ backgroundImage: `url(${contact.avatar})` }"
    ></div>
    <div class="shop-contact__info">
      <div class="shop-contact__name">{{ contact.name }}</div>
      <div v-if="contact.title" class="shop-contact__title">{{ contact.title }}</div>
      <div class="shop-contact__contact">
        <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
        <a v-if="contact.phone" :href="`tel:${contact.phone}`">{{ contact.phone }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shop: Object,
  },
  computed: {
    contact() {
      return this.$path('shop.reference.project.roles.shop.salesman.0')
    },
  },
}
</script>

<style lang="scss">
.shop-contact {
  display: flex;
  gap: 1rem;

  &__name {
    font-weight: bold;
  }

  &__title {
    opacity: 0.7;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__contact {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  a {
    color: var(--shop-text-color);
  }

  &__thumbnail {
    $size: 68px;

    width: $size;
    height: $size;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    background-color: css-alpha('border-color', 0.4);
    border-radius: 50%;
    color: css-darken('border-color', 20%);

    grid-row: 1 / -1;
  }
}
</style>
